<script>
export const group = 'Full'
</script>

<script setup>
import { colors } from '../../../tailwindTheme.config.js'
import AnimatedBackground from '../../AnimatedBackground.vue'
import ToFullBottomRight from './transitions/energetic_frequencies/ToFullBottomRight.vue'
import EFLoopAudioLevels02 from '../../../assets/animations/energetic_frequencies/loops/audio_levels_02.json'
import TextSlideUp from './text_animations/TextSlideUp.vue'
import StopwatchBlocks from './shared/StopwatchBlocks.vue'
import VideoPlayer from '../../VideoPlayer.vue'
const gsapTimeline = useGsapTimeline()

defineProps({
  item: Object,
})

const scheme = { backgroundColor: colors.q.cr.gray.primary, color: colors.q.cr.gray.darker }

const timelineTitleAbove = ref(null)
const timelineTitleBelow = ref(null)
const timelineStopwatch = ref(null)

onMounted(() => {
  gsapTimeline({ name: 'Stopwatch' }).add(timelineTitleAbove, frames(15)).add(timelineStopwatch).add(timelineTitleBelow, '-=0.48')
})
</script>

<template>
  <ToFullBottomRight>
    <AnimatedBackground :lottie="EFLoopAudioLevels02" :backgroundColor="scheme.backgroundColor" :color="scheme.color" :scale="3">
      <VideoPlayer v-if="item.properties.backgroundVideo" :src="item.properties.backgroundVideo" class="absolute size-full object-cover" autoplay muted loop />
      <div class="px-32 flex flex-col justify-center items-center h-full text-white space-y-12">
        <TextSlideUp :text="item.properties.titleAbove || ''" class="text-[10rem] font-bold leading-none" @timeline="timelineTitleAbove = $event" />
        <StopwatchBlocks :stopwatch="item.enrichment.stopwatch" :showDays="!item.properties.showDaysAsHours" @timeline="timelineStopwatch = $event" />
        <TextSlideUp :text="item.properties.titleBelow || ''" class="text-[10rem] font-bold leading-none" @timeline="timelineTitleBelow = $event" />
      </div>
    </AnimatedBackground>
  </ToFullBottomRight>
</template>
